(function () {
    'use strict';

    var thirdPartyService = function ($http) {

        this.getForensicsParams = function(token) {
            return $http.post('api/thirdparty/getForensicsUrl',
                {
                    token: token
                })
                .then(function(response) {
                        var urlParams = response.data.urlParams;

                        return urlParams;
                    },
                    function() {
                        throw ('Error getting Forensics URL');
                    });
        };

        this.getForensicsToken = function (linkId) {
            return $http.get('api/thirdparty/getForensicsToken/' + linkId)
                .then(function(response) {
                        var token = response.data.token;

                        return token;
                    },
                    function() {
                        throw ('Error getting Forensics token');
                    });
        };

        this.getSEO = function () {
            return $http.get('api/thirdparty/seo')
                .then(function (response) {
                        var url = response.data.url;

                        return url;
                    },
                    function () {
                        throw ('Error getting static url');
                    });
        };
    }

    angular.module('app')
        .service('thirdPartyService', ['$http', thirdPartyService]);
})();